import { api } from './client';
import type { UsageLog } from '@/types/usage';

export const usageApi = {
  async getAll(): Promise<UsageLog[]> {
    const response = await api.get('/equipment/usage-logs/');
    return response.data;
  },

  async create(data: Partial<UsageLog>): Promise<UsageLog> {
    const response = await api.post('/equipment/usage-logs/', data);
    return response.data;
  },

  async getById(id: number): Promise<UsageLog> {
    const response = await api.get(`/equipment/usage-logs/${id}/`);
    return response.data;
  },

  async update(id: number, data: Partial<UsageLog>): Promise<UsageLog> {
    const response = await api.patch(`/equipment/usage-logs/${id}/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/equipment/usage-logs/${id}/`);
  },

  async getUsageReport(params?: { days?: number | string; start_date?: string; end_date?: string }): Promise<import('@/types/usage').EquipmentUsageReport> {
    const response = await api.get('/reports/comprehensive/equipment-usage/', { params });
    return response.data?.usage;
  },
};
